import { NotificationsService } from 'app/_services/notifications.service';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

export enum KEY_CODE {
  ENTER = 13,
  ESCAPE = 27,
}

@Component({
  selector: 'app-inline-input',
  templateUrl: './inline-input.component.html',
  styleUrls: ['./inline-input.component.css'],
})
export class InlineInputComponent implements OnInit {
  @Input() value: string;
  @Input() format = 'string';

  @Output() callback = new EventEmitter<any>();

  readOnly: boolean;
  oldValue: any;

  constructor(protected notificationsService: NotificationsService) {}

  onKey(event: KeyboardEvent) {
    if (event.keyCode === KEY_CODE.ENTER) {
      this.save(event);
    }

    if (event.keyCode === KEY_CODE.ESCAPE) {
      this.cancel(event);
    }
  }

  ngOnInit() {
    this.readOnly = true;
  }

  edit(event) {
    event.preventDefault();
    this.oldValue = this.value;
    this.readOnly = false;
  }

  cancel(event) {
    event.preventDefault();
    this.value = this.oldValue;
    this.readOnly = true;
    this.notificationsService.notify('error', 'Cancelación', 'Edición cancelada');
  }

  save(event) {
    event.preventDefault();
    const data = {
      value: this.value,
      oldValue: this.oldValue,
    };
    this.callback.emit(data);
    this.readOnly = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/inline-input/inline-input.component.ts